module.exports = "/img/why.514bbe70.png";